import type { CheckedChangedEventHandler } from '@sunwebgroup/ui-components'
import { useIntl } from '@/intl'

import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { ChoiceListItem } from '@sunwebgroup/ui-components'

import { equals, isEmpty, reject } from 'ramda'
import * as React from 'react'
import { ShowMore } from '../../../../../../common/components/ShowMore'
import { createSearchFilterClickEvent } from '../../../../domain/analytics'
import { useMultiSelectFilter } from '../../../../domain/hooks'
import FilterGroup from './FilterGroup'

export function CollectionsFilter() {
  const intl = useIntl()
  const { sendEvent } = useAnalytics()
  const { isFetching, options, selectedValues, setSelection } = useMultiSelectFilter('Collection')

  const handleFilterChange: CheckedChangedEventHandler = ({ checked, value }) => {
    if (checked) {
      setSelection([...selectedValues, value])
      sendEvent(
        createSearchFilterClickEvent({
          element: 'checkbox',
          type: 'labels',
          result: [...selectedValues, value].join(','),
        }),
      )
    }

    if (!checked) {
      setSelection(reject(equals(value), selectedValues))
    }
  }

  if (isEmpty(options))
    return null

  return (
    <FilterGroup
      title={intl.formatMessage({ id: 'search_filter_collections_label' })}
      defaultOpen={selectedValues.length > 0}
    >
      <ShowMore
        openLabel={intl.formatMessage({ id: 'show_more' })}
        closeLabel={intl.formatMessage({ id: 'show_less' })}
      >
        {options.map(({ name, value, resultsCount }) => (
          <ChoiceListItem
            choiceListItemType="checkbox"
            key={name}
            value={value}
            checked={selectedValues.includes(value)}
            label={name}
            quantity={resultsCount}
            onCheckedChange={handleFilterChange}
            disabled={isFetching}
          />
        ))}
      </ShowMore>
    </FilterGroup>
  )
}
